import React, { useState, useMemo, useCallback, useRef } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import AssessmentContent from "@/components/assessment/AssessmentContent"
import QuestionnaireProgress from "@/components/assessment/QuestionnaireProgress"
import AssessmentContext from "@/components/assessment/AssessmentContext"

const useStyles = makeStyles(() => ({
    assessmentWrapper: {
        display: "flex",
        flexDirection: "column",
    },
}))

const AssessmentMain = (props) => {
    const { headerHeight, questionsDetail, responses, participantDetail, updateParticipantDetail } = props
    const [nextQuestionIndex, setNextQuestionIndex] = useState(0)
    const totalQuestion = useMemo(() => {
        return questionsDetail?.length
    }, [questionsDetail])
    const [finalResponse, setFinalResponse] = useState([])
    const totalResponse = useMemo(() => {
        return Math.max(responses?.length, finalResponse.length)
    }, [responses, finalResponse])
    const getFinalResponse = useCallback(
        (finalResponseValue) => {
            setFinalResponse(finalResponseValue)
        },
        [responses, finalResponse]
    )
    const classes = useStyles()
    const assessmentContentWrapperRef = useRef()
    return (
        <Box className={classes.assessmentWrapper}>
            <AssessmentContext.Provider
                value={{ headerHeight, participantDetail, nextQuestionIndex, setNextQuestionIndex, updateParticipantDetail }}
            >
                <QuestionnaireProgress
                    totalQuestion={totalQuestion}
                    totalResponse={totalResponse}
                    assessmentContentWrapperElement={
                        assessmentContentWrapperRef.current ? assessmentContentWrapperRef.current.getAssessmentWrapperElement() : null
                    }
                />
                <AssessmentContent
                    questionsDetail={questionsDetail}
                    responses={responses}
                    ref={assessmentContentWrapperRef}
                    getFinalResponse={getFinalResponse}
                />
            </AssessmentContext.Provider>
        </Box>
    )
}

export default AssessmentMain
